import createIcon from '../../createIcon';

/**
 * @component @name EditOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNjM0OCA4LjEyNTQzTDE0LjU3MTggNi4xODg0M0wxOC4zMTg4IDkuOTM1NDNMMTYuMzgxOCAxMS44NzM0TDEyLjYzNDggOC4xMjU0M1pNMjEuMjE4OCA1LjYzMDQzTDE4Ljg3ODggMy4yOTA0M0MxOC42OTE0IDMuMTA0MTggMTguNDM4IDIuOTk5NjMgMTguMTczOCAyLjk5OTYzQzE3LjkwOTYgMi45OTk2MyAxNy42NTYyIDMuMTA0MTggMTcuNDY4OCAzLjI5MDQzTDE1LjYzODggNS4xMjA0M0wxOS4zODg4IDguODcwNDNMMjEuMjE4OCA3LjAwMDQzQzIxLjM5MzIgNi44MTQ5NyAyMS40OTAyIDYuNTY5OTkgMjEuNDkwMiA2LjMxNTQzQzIxLjQ5MDIgNi4wNjA4NiAyMS4zOTMyIDUuODE1ODkgMjEuMjE4OCA1LjYzMDQzWk0yLjUwODc5IDUuMDAwNDNMOS4xMzg3OSAxMS42MzA0TDMuNTA4NzkgMTcuMjUwNFYyMS4wMDA0SDcuMjU4NzlMMTIuODg4OCAxNS4zODA0TDE4LjUwODggMjEuMDAwNEwyMC41MDg4IDE5LjAwMDRMNC41MDg3OSAzLjAwMDQzTDIuNTA4NzkgNS4wMDA0M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditOff = createIcon('EditOff', [
  [
    'path',
    {
      d: 'M12.6348 8.12543L14.5718 6.18843L18.3188 9.93543L16.3818 11.8734L12.6348 8.12543ZM21.2188 5.63043L18.8788 3.29043C18.6914 3.10418 18.438 2.99963 18.1738 2.99963C17.9096 2.99963 17.6562 3.10418 17.4688 3.29043L15.6388 5.12043L19.3888 8.87043L21.2188 7.00043C21.3932 6.81497 21.4902 6.56999 21.4902 6.31543C21.4902 6.06086 21.3932 5.81589 21.2188 5.63043ZM2.50879 5.00043L9.13879 11.6304L3.50879 17.2504V21.0004H7.25879L12.8888 15.3804L18.5088 21.0004L20.5088 19.0004L4.50879 3.00043L2.50879 5.00043Z',
      key: '1jsvv0',
    },
  ],
]);

export default EditOff;
